module.exports = __webpack_public_path__ + "static/img/icon9.ffba1faf.png";